module.exports = {
  BLOG_LOCALES: ['de', 'fr'],
  DEFAULT_LOCALE: 'en',
  LOCALES: ['de', 'en', 'es', 'fr', 'it', 'nl', 'sv'],
};
